function treatmentTypeCountByLower(buckets) {
  let countByLower = new Map();

  for (let bucket of buckets) {
    let key = bucket?.key;

    if (!key) continue;

    let lower = key.toLowerCase();
    countByLower.set(lower, (countByLower.get(lower) ?? 0) + Number(bucket.count ?? 0));
  }

  return countByLower;
}

function sortedTreatmentTypeNames(records) {
  let labelByLower = new Map();

  for (let record of records) {
    for (let name of record?.treatmentTypes ?? []) {
      let lower = name.toLowerCase();

      if (!labelByLower.has(lower)) {
        labelByLower.set(lower, name);
      }
    }
  }

  return [...labelByLower.values()].sort((a, b) => a.localeCompare(b));
}

export function buildTreatmentTypeFacetOptions(records = [], buckets = []) {
  let countByLower = treatmentTypeCountByLower(buckets);

  return sortedTreatmentTypeNames(records).map(name => ({
    key: name,
    label: name,
    docCount: countByLower.get(name.toLowerCase()) ?? 0,
  }));
}
